<template>
  <option-general value="exit" :label="$t('edit.sidebar.when_leave_the_page')"></option-general>
</template>

<script>
import OptionGeneral from './general/Main.vue';

export default {
  components: {
    OptionGeneral,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Exit.vue?4ecb0514
 **/